import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
export const useCreateGuildValidationSchema = () => {
    const { t } = useTranslation();
    return Yup.object().shape({
        name: Yup.string().required('Guild name is required')
    });
};
